import {Register} from "../genes/Register"

export const IMap = {}
